import { graphql } from '../../gql';

const basketQuery = graphql(/* GraphQL */ `
  query BasketQuery {
    cart_query {
      carts {
        customerOrderId
        customerId
        currencyId
        shipmentAddressId
        items {
          name
          description
          orderItemId
          quantity
          designId
          thumbnailUrl
          price {
            initial {
              formatted
            }
            discount {
              formatted
            }
            total {
              formatted
            }
          }
          previewUrl
          quantityOptions {
            quantityOptions {
              quantity
              isDefault
              batchName
              prices {
                price {
                  value
                  formatted
                  currencyId
                }
                priceWithDiscountAccordingToVatOption {
                  value
                  formatted
                  currencyId
                }
              }
            }
          }
        }
      }
      totals {
        productInitial {
          value
          formatted
          currencyId
        }
        productDiscount {
          value
          formatted
          currencyId
        }
        productTotal {
          value
          formatted
          currencyId
        }
        shippingInitial {
          value
          formatted
          currencyId
        }
        shippingDiscount {
          value
          formatted
          currencyId
        }
        shippingTotal {
          value
          formatted
          currencyId
        }
        totalInitial {
          value
          formatted
          currencyId
        }
        totalDiscount {
          value
          formatted
          currencyId
        }
        total {
          value
          formatted
          currencyId
        }
        totalVat {
          value
          formatted
          currencyId
        }
        productTotalVat {
          value
          formatted
          currencyId
        }
        shippingTotalVat {
          value
          formatted
          currencyId
        }
      }
    }
  }
`);

export default basketQuery;
